import { isPlainObject } from "utils/general";

export const DEFAULT_PER_PAGE = 25;
export const ALL_ROWS_PER_PAGE_OPTION = {
	label: "osfc.paginations.all",
	value: 10000
};
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [
	DEFAULT_PER_PAGE,
	100,
	ALL_ROWS_PER_PAGE_OPTION
];

export const translatePaginationOptions = (options, translate) =>
	options.map((opt) => {
		if (!isPlainObject(opt)) return opt;
		return { ...opt, label: translate(opt.label) };
	});
